<template>
    <svg :width="svgWidth" :height="svgHeight" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.662 6.71H2.73C2.73 6.32733 2.84667 5.94933 3.08 5.576
        C3.31333 5.20267 3.58867 4.89 3.906 4.638
        C4.69 4.00333 5.082 3.42467 5.082 2.902
        C5.082 2.57533 4.97 2.32333 4.746 2.146
        C4.522 1.96867 4.20933 1.88 3.808 1.88
        C3.024 1.88 2.46867 2.29533 2.142 3.126L0.49 2.174
        C0.77 1.49267 1.21333 0.960666 1.82 0.577999
        C2.42667 0.195333 3.11267 0.00399935 3.878 0.00399935
        C4.718 0.00399935 5.45067 0.251333 6.076 0.746
        C6.70133 1.23133 7.014 1.90333 7.014 2.762
        C7.014 3.14467 6.93 3.50867 6.762 3.854
        C6.60333 4.19 6.40733 4.47933 6.174 4.722
        C5.95 4.95533 5.72133 5.17933 5.488 5.394
        C5.264 5.59933 5.068 5.814 4.9 6.038
        C4.74133 6.262 4.662 6.486 4.662 6.71ZM4.886 8.992
        C4.886 9.31867 4.76933 9.59867 4.536 9.832
        C4.30267 10.0653 4.02267 10.182 3.696 10.182
        C3.36933 10.182 3.08933 10.0653 2.856 9.832
        C2.62267 9.59867 2.506 9.31867 2.506 8.992
        C2.506 8.66533 2.62267 8.38533 2.856 8.152
        C3.08933 7.91867 3.36933 7.802 3.696 7.802
        C4.02267 7.802 4.30267 7.91867 4.536 8.152
        C4.76933 8.38533 4.886 8.66533 4.886 8.992Z"
        :fill="color"/>
    </svg>
  </template>
  <script>
  export default {
    props: {
      width: {
        type: String,
        default: '8',
      },
      height: {
        type: String,
        default: '11',
      },
      color: {
        type: String,
        default: '#353535',
      },
    },
    data() {
      return {
        isHover: false,
      };
    },
    computed: {
      svgWidth() {
        return this.width;
      },
      svgHeight() {
        return this.height;
      },
    },
  };
  </script>
